import { Result } from 'src/models/Result.model';
import { Session } from 'src/models/Session.model';

const checkIsGradable = (results: Result[]) => {
  return !results.some(
    (res) =>
      res === undefined || res.error !== undefined || res.gradable === false,
  );
};

export default function getGradingResult(session: Session) {
  const isLeftEyeGradable =
    !!session.leftResults?.length && checkIsGradable(session.leftResults);

  const isRightEyeGradable =
    !!session.rightResults?.length && checkIsGradable(session.rightResults);

  const totalGradableEyes =
    (isLeftEyeGradable ? 1 : 0) + (isRightEyeGradable ? 1 : 0);

  return {
    isLeftEyeGradable,
    isRightEyeGradable,
    totalGradableEyes,
  };
}
